import { useState, useRef, useEffect } from 'react';
import { Select, FormControl, InputLabel, SelectChangeEvent } from '@mui/material';

interface Props {
  values: React.ReactNode;
  id: string;
  onChange?: (event: SelectChangeEvent<string>) => void;
  selectedPropsValue?: string;
  label: string;
  name?: string;
  required?: boolean;
  inputLabel?: HTMLLabelElement | null;
  width?: number;
}

const Dropdown: React.FC<Props> = (props) => {
  const inputLabel = useRef<HTMLLabelElement>(props.inputLabel ? props.inputLabel : null);
  const [selectValue, setSelectValue] = useState('');
  const [valueChanged, setValueChanged] = useState(false);

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setValueChanged(true);
    setSelectValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <FormControl
      variant="outlined"
      required={props.required ? props.required : false}
      sx={{
        margin: 0,
        minWidth: '150px',
        width: `${props.width ? props.width : 100}%`,
      }}
    >
      <InputLabel
        ref={inputLabel}
        id={props.id}
        shrink={true}
      >
        {props.label}
      </InputLabel>
      <Select
        native
        labelId={props.id}
        required={props.required ? props.required : false}
        id={props.id}
        name={props.name}
        value={
          props.selectedPropsValue && !valueChanged
            ? props.selectedPropsValue
            : selectValue
        }
        onChange={handleSelectChange}
        label={props.label}
        notched={true}
      >
        {props.values}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
